import L from 'leaflet';
export class HotlineCanvas extends L.Canvas {
    constructor(renderer, options) {
        super(Object.assign(Object.assign({}, options), { tolerance: 2000 }));
        this._renderer = renderer;
    }
    _initContainer() {
        ;
        L.Canvas.prototype._initContainer.call(this);
        this._renderer.setCanvas(this._container);
    }
    _destroyContainer() {
        ;
        L.Canvas.prototype._destroyContainer.call(this);
    }
    _update() {
        if (this._map === null)
            return;
        L.Canvas.prototype._update.call(this);
        this._renderer.width(this._container.width);
        this._renderer.height(this._container.height);
    }
    _updatePoly(layer) {
        const parts = layer._parts;
        if (!parts.length) {
            return;
        }
        this._renderer.data(parts).draw();
    }
}
